export default {
  buttons: {
    start: 'Start preparing scheduled order',
  },
};
